import { ActionIcon as ActionIconComponent } from '@mantine/core'

import classNames from './action-icon.module.css'

declare module '@mantine/core' {
  export interface ActionIconProps {
    variant?:
      | 'filled'
      | 'light'
      | 'outline'
      | 'transparent'
      | 'white'
      | 'subtle'
      | 'default'
      | 'gradient'
      | 'neutral'
  }
}

export const ActionIcon = ActionIconComponent.extend({
  defaultProps: {
    variant: 'subtle',
  },
  classNames,
})
